export default __webpack_public_path__ + "static/media/TSD.2430fa58.png";